module.exports = __webpack_public_path__ + "7035f5929e71e5413658eb3ed7c38ee8.svg";